import React, { useState } from 'react';
import { Box } from '@mui/material';

const BRAND_ICON_SLUGS = {
  chatgpt: 'openai',
  claude: 'anthropic',
  codex: 'openai',
  cursor: 'cursor',
  googleDrive: 'googledrive',
  notion: 'notion',
  sharePoint: 'microsoftsharepoint',
};

// These two marks are not present under their expected slugs in Simple Icons v16.
const BRAND_ICON_URLS = {
  chatgpt: 'https://cdnjs.cloudflare.com/ajax/libs/simple-icons/11.8.0/openai.svg',
  codex: 'https://cdnjs.cloudflare.com/ajax/libs/simple-icons/11.8.0/openai.svg',
  sharePoint: 'https://icons.iconarchive.com/icons/simpleicons-team/simple/128/microsoft-sharepoint-icon.png',
};

const IntegrationLogo = ({ brand, alt, size = 22, muted = false }) => {
  const [failed, setFailed] = useState(false);
  const slug = BRAND_ICON_SLUGS[brand];
  const src = BRAND_ICON_URLS[brand] || (slug ? `https://cdn.jsdelivr.net/npm/simple-icons@16.0.0/icons/${slug}.svg` : '');

  if (!src || failed) {
    return <Box sx={{ width: size, height: size, flex: `0 0 ${size}px` }} aria-hidden />;
  }

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      onError={() => setFailed(true)}
      sx={{
        width: size,
        height: size,
        flex: `0 0 ${size}px`,
        alignSelf: 'center',
        display: 'block',
        objectFit: 'contain',
        opacity: muted ? 0.42 : 1,
        filter: muted ? 'grayscale(1)' : 'none',
      }}
    />
  );
};

export default IntegrationLogo;
